import { getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');
const mdSpacing = getTheme('spacing.md');

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${mdSpacing}px;
`;

export const StyledCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  border: 2px solid ${textMain};
  border-radius: 50%;
  outline: none;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:checked {
    background-color: ${textMain};
    border-color: ${textMain};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${pxToRem(12)};
    height: ${pxToRem(12)};
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Label = styled.span`
  font-size: ${pxToRem(16)};
  line-height: 1.5;
  color: ${textMain};
  cursor: pointer;
`;
